export default __webpack_public_path__ + "static/media/change.86a5e1f1.svg";